// extracted by mini-css-extract-plugin
module.exports = {"dealer-logo__height":"alp_dealer-logo__height___KNKc","location-link-ellipses":"alp_location-link-ellipses__8Zepz"};